import { GET_OFFICERS_SUCCESS } from './';

export default (data, payload) => ({
  type: GET_OFFICERS_SUCCESS,
  payload: { ...payload, data },
});
